module.exports = __webpack_public_path__ + "nunito-sans-latin-600italic.9db53e390a5327462f45889e249f84d6.woff";